module.exports = __webpack_public_path__ + "img/采集机器.66768895.png";